import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
// import {ConnectedRouter} from 'react-router-redux'

import App from './App'
//import AppExamples from './AppExamples';
import configureStore from './configureStore'
import registerServiceWorker from './registerServiceWorker';
import rootReducer from './reducers'

const store = configureStore(rootReducer,{ breadcrumbs: []}) // firebase: {},

// Listen for auth ready (promise available on store thanks to attachAuthIsReady: true config option)
store.firebaseAuthIsReady.then(() => {
    console.log('Auth has loaded') // eslint-disable-line no-console
})



/*
   "homepage" : "https://rep.strata.ph/app_report",
 public/index.html
 package.json
 \\DESKTOP-GA4PQDV\temp\manifests
        
        <AppExamples />
        // AppExamples Router conflicts with Office in index.html
       
 */
/* Render application after Office initializes */

    ReactDOM.render(
    <Provider store={store}>
         <App />
    </Provider>,
    document.getElementById('root')
    );

registerServiceWorker();






// WEBPACK FOOTER //
// ./src/index.js